import './styles/index.css';
import '@tabler/icons-webfont/dist/tabler-icons.min.css';

import { initTheme } from './core/theme';
import { api } from './services/api-client';
import { auth, session } from './services/auth-service';

// Bileşen kayıtları (custom element tanımları yan etkiyle yüklenir)
import './components/smg-toast';
import './components/smg-confirm';
import './components/ssh-panel';
import './components/app-shell';
import './views/login-view';
import './views/devices-view';
import './views/device-detail-view';
import './views/brands-view';
import './views/scripts-view';
import './views/users-view';
import './views/wg-view';
import './views/settings-view';

initTheme();

// 401 → oturumu düşür; kabuk login ekranına döner
api.setUnauthorizedHandler(() => {
  if (session.get().user) {
    session.set({ user: null, claims: null, loading: false });
  }
});

void auth.bootstrap();
